// npm packages
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

// project imports
import { CardEffect } from "./CardEffect/CardEffect";

// assets
import me from "../assets/img/me/foto9.jpg";

import "animate.css";

import "./About.css"

export const About = () => {
  const { t } = useTranslation();

  return (
    <section className="about" id="about">
      <Container>
      {/* text-center text-sm-end */}
      {/* <Row className="align-items-center justify-content-center flex-column-reverse flex-md-row gap-5"> */}
      <Row className="align-items-center justify-content-center flex-column-reverse flex-md-row gap-0 gap-sm-5">
          <Col size={12} md={3}>
            <div className="animate__animated animate__zoomIn d-flex card-container">
              <CardEffect
                image={me}
                text={t("about.downloadCV")}
                className="m-auto m-md-0"
              />
            </div>
          </Col>
          <Col size={12} md={6}>
            <div className="animate__animated animate__fadeIn">
              <h2>{t("about.title")}</h2>

              <p>
                {t("about.paragraph1")}
              </p>
              <p>
                {t("about.paragraph2")}
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
